import React, { SetStateAction, SyntheticEvent, useEffect, useState } from 'react';
import './product_details.css';
import { BrandsService } from '../../../service/brands.service';
import { Brand } from '../../../model/brand.model';
import { CategoryService } from '../../../service/categories.service';
import { Category } from '../../../model/category.model';
import { ProductFeature, fields_error } from '../../../model/product-feature.model';
import { v4 as uuidv4 } from 'uuid';
import FormBuilder from '../../../components/form-builder';
import { ProductService } from '../../../service/product.service';
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, FormControl, FormLabel, IconButton, InputAdornment, MenuItem, Radio, RadioGroup, Stack, TextField, makeStyles, setRef } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

import { FormControlLabel } from '@mui/material';
import { transform } from 'typescript';
import { useLocation } from 'react-router-dom';

import RemoveCircleOutlineTwoToneIcon from '@mui/icons-material/RemoveCircleOutlineTwoTone';
import AddCircleOutlineTwoToneIcon from '@mui/icons-material/AddCircleOutlineTwoTone';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { numberValidations } from '../../../components/form-builder/form-validations';
import MyCustomNotification from '../../../common/MyCustomNotification';
import { isValidFileName } from "../../../utils/config";

//import { merge } from 'lodash';

function ProductDetails(this: any) {
  const brandsService = new BrandsService();
  const categoryService = new CategoryService();
  const productService = new ProductService();
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const [availableCategories, setAvailableCategories] = useState<Category[]>([]);
  const [availableSubCategories, setAvailableSubCategories] = useState<Category[]>([]);
  const [productList, setProductList] = useState<ProductFeature[]>([]);

  //const [tempProductList, setTempProductList] = useState<ProductFeature[]>([]);

  const [productFormData, setProductFormData] = useState<any>({});

  const [response, setResponse] = useState<any>({});

  const [productCommonDataDelta, setProductCommonDataDelta] = useState<any>({});

  const [availableSizes, setAvailableSizes] = useState([]);
  const [availableFinishes, setAvailableFinishes] = useState([]);
  //const [errMsg, setErrMsg] = useState('');
  const navigate = useNavigate();

  const [isEditMode, setIsEditMode] = useState(false);
  const [editableFields, setEditableFields] = useState<any>({});
  const [canShowForm, setCanShowForm] = useState(false);
  const params = useParams();
  const brandId = params.brandid;
  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
  const [selectedCatId, setSelectedCatId] = React.useState("select");
  const [selectedSubCatId, setSelectedSubCatId] = React.useState("select");
  // Original brand + sub-category captured at edit-load. When a product is MOVED to another
  // brand/sub-category these are sent as oldBrandId/oldProdCatId so the backend also refreshes
  // the OLD category's Redis list (else the product lingers under its old brand). Issue #1 fix 2026-06-24.
  const [origBrandId, setOrigBrandId] = React.useState("");
  const [origSubCatId, setOrigSubCatId] = React.useState("");
  const [isNew, setIsNew] = React.useState("");
  const [cadState, setCadState] = React.useState("");
  const [refImgState, setRefImgState] = React.useState("");
  const [featImgState, setFeatImgState] = React.useState("");

  //const [prodDispName, setProdDispName] = React.useState("");
  

 // const [dispImgState, setDispImgState] = React.useState("");
  // let sCats: Category[] ;


  const location = useLocation();
  const parameters = { brand: "", modelNum: "", action: "", category: "", mainCategory: "" };
  const [openDlg, setDlgOpen] = useState(false);
  const [checkBoxClickCount, setcheckBoxClickCount] = useState(0);

  const[errorMsg,setErrorMsg]= useState("");
 
  const fileErrormsg = "File name should contain characters [a-z] , [A-Z] , [0-9] or Underscore [ _ ] ";

  useEffect(() => {
    //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
    if (Number({ selectedBrandId }) > 0) {
      loadAllCategories(Number({ selectedBrandId }));
    }
  }, []);

  const handleIsNew = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    setIsNew(value);
  }

  

  const setselectedSize = (event: any, value: string, index: number) => {

    //console.log('sell :: ',event.target.name);
    let feature = productList[index];
    //console.log('sell ', feature);
    feature.size = value;
    productList[index] = feature;
    setProductList([...productList]);


 

  // alert("size :: "+JSON.stringify(tempProductList) );

  }



  const setselectedFinish = (event: any, value: string, index: number) => {
  
    let feature = productList[index];

    feature.finish = value;
    productList[index] = feature;
    setProductList([...productList]);

   
  }

  const handleStatus = (event: any, value: string , index: number) => {
  
    let feature = productList[index];

    feature.status = Number(value);
    productList[index] = feature;
    setProductList([...productList]);

   
  }


  const loadAllBrands = () => {

    brandsService.brands(1).then(data => {
      const res = data.data;
      setAvailableBrands(res);

    });
  }

  const loadAllCategories = (brand: Number) => {
    // if (!productFormData?.value?.iBrandId) {
    //   return;
    // }
    //console.log("-------------selectedBradId : " + brand);
    setSelectedCatId("select");
    setSelectedSubCatId("select");
    categoryService.categories(Number(brand)).then(data => {
      const res = data.data;
      setAvailableCategories(res);
      /*if (res[0]) {
        loadSubCategories(res[0].catId);
      }*/
    });
  }

  const loadAllSizes = () => {
    productService.getProductSizes(selectedBrandId).then(data => {
      const res = data.data;
      setAvailableSizes(res);
    })
  }

  const loadAllFinishes = () => {
    productService.getProductActiveFinishes(selectedBrandId).then(data => {
      const res = data.data;
      setAvailableFinishes(res);
    })
  }

  const loadSubCategories = (scatId: number) => {


    setSelectedSubCatId("select");
    // console.log("~~~~~~~~~~~~~~~selectedBrandId:" + Number(selectedBrandId) + ",sCatId: " + Number(scatId));
    categoryService.subCategories(Number(selectedBrandId), Number(scatId)).then(data => {
      const res = data.data;
      // setAvailableCategories(res);
      const sCats: Category[] = res.filter((el: any) => el.parentId === scatId);

      setAvailableSubCategories(sCats);
    }).catch(err => {
      setAvailableSubCategories([]);
    });
  }

  const loadProductData = (brand: number, model: string) => {
    productService.getProductData(brand, model).then(res => {
      if (res.data && res.data[0]) {

        const response =  res.data[0];

        setResponse(response)

        const { groupModelNo, modData , prodDispName } = res.data[0];

        //console.log("data :: "+  JSON.stringify( res.data[0]) )
        //console.log("data : :"+ JSON.stringify( response))
        

      //  productFormData.prodDispName = response.prodDispName;

        // productFormData.groupModelNo = response.groupModelNo;

        setProductFormData( { ...response , brandId: brand} );

      //  console.log("data ::: "+ productFormData.prodDispName)

        // setProdDispName(response.prodDispName)

        setCadState(res.data[0].cad);
        setRefImgState(res.data[0].refImg);
        setFeatImgState(res.data[0].featureList);
            

        if (modData) {
          const features: any = [];

          for (let modindex = 0; modindex < modData.length; modindex++) {

            for (let index = 0; index < modData[modindex].details.length; index++) {
              //setDispImgState(  modData[0].details[index].dispImg);
              const finish = modData[modindex].finish
              const element = modData[modindex].details[index];
              const dispimg = modData[modindex].details[index].dispImg.split("/").pop();
              const prodCodeOldvalue =  modData[modindex].details[index].prodCode;
              
              features.push({ ...element, prodCodeOld :prodCodeOldvalue ,  finish: finish, dispImg:dispimg , feature_errors:new fields_error });
              //console.log("from resp :: "+features[0].prodId);

            }
          }

          setProductList(features);         
        
        }
      }
    });
  }


  useEffect(() => {

    console.log("eeee " + selectedBrandId)

    if (selectedBrandId == "select") {
      return;
    }
    loadAllSizes();
    loadAllFinishes(); // saii   

  }, [selectedBrandId])

  let isLoadDataInit = false;

  useEffect(() => {

    if (!isLoadDataInit) {

      if (location != null && location.state != null) {
        parameters.modelNum = location.state.modelNum;
        parameters.action = location.state.action;
        parameters.brand = location.state.selectedBrand;
        parameters.category = location.state.categoryId;
        parameters.mainCategory = location.state.maincategoryId;
      }

      isLoadDataInit = true;
      // console.log("opppppppppp")

      setProductFormData({
        
          prodDispName: "",

          "groupModelNo": "",
          "cad": "",
          "refImg": "",
          "remark": "",
          "videoUrl": "",
          "featureList": "",
          "isnew": ""
        
      });

      //console.log("opppppppppp", productFormData)

      // loadAllSizes();
      //  loadAllFinishes(); // saii

      if ((parameters.action == 'view') || (parameters.action == 'edit')) {
        setAvailableBrands(location.state.availableBrands);
        setAvailableCategories(location.state.availableCategories);
        setAvailableSubCategories(location.state.availableSubCategories);

        setSelectedBrandId(parameters.brand);
        setSelectedCatId(parameters.mainCategory);
        setSelectedSubCatId(parameters.category);
        // remember the originals so a later brand/sub-category move can refresh the old cache
        setOrigBrandId(parameters.brand);
        setOrigSubCatId(parameters.category);
      }


      if ((parameters.action == 'view') && parameters.brand && parameters.modelNum != '0') {
        setSelectedBrandId(parameters.brand)
        setSelectedSubCatId(parameters.category)
        unsetFieldKeys();
        setCanShowForm(true);
        setIsEditMode(true);
        loadProductData(Number(parameters.brand), parameters.modelNum);
        //console.log("useeffect : view ");
        // forceUpdate()
      } else if (parameters.modelNum && parameters.brand && parameters.modelNum != '0') {
        setSelectedBrandId(parameters.brand)
        setSelectedSubCatId(parameters.category)
        setCanShowForm(false);
        setIsEditMode(true);
        loadProductData(Number(parameters.brand), parameters.modelNum);
        //console.log("useeffect : edit ");
      } else {
        loadAllBrands();
        setCanShowForm(true);
      }
    }
  }, [brandId != "add"]);

  const onAddNewFeature = () => {

  //  alert(isEditMode)

 

    const features = productList;
    let  uuidvalue  =  uuidv4()
    features.push({
      prodCode: '',
      modelNum: '',
      finish: '',
      sizeUnit: '',
      size: '',
      mrp: '',
      stock: '',
      dispImg: '',
      dispImgData: '',
      selectedSizes: [],
      uuid: uuidvalue, // uuidv4(),
      prodId:-99,
      isedited:false,
      status:1,
      feature_errors: new fields_error,
      prodCodeOld : ''
    });
    setProductList([...features]);

   
  }

  const onRemoveFeature = (element: ProductFeature) => {
    {
    const features = productList;
    const index = productList.findIndex(el => el === element);
    features.splice(index, 1);
    setProductList([...features]);
    }
 

  }

  const handleModelData_check = (index: number, data: any) => { // sai check here
    
  
    const { mrp, stock, prodCode, modelNum ,size , finish } = data.value;

    let productlocal:ProductFeature = productList[index];
    const  newvalue = { ...productlocal, mrp, stock, prodCode, modelNum , size , finish };
   //const  featurenew = { ...feature };

    newvalue.isedited = true;

    productList[index] = newvalue;
    setProductList([...productList]);
    console.log("handleModelData : ", productList)
  }

  const handleModelData = (index: number, data: any) => { // sai check here

     
    const { mrp, stock, prodCode, modelNum  } = data.value;

   // alert(mrp+" : " + stock+ " : " +prodCode+ " : " +modelNum )
    
    let feature:any = productList[index];

    
    console.log("handleModelData ***** : "+ JSON.stringify(feature));
   // const  newvalue = { ...feature, mrp, stock, prodCode, modelNum , size };
   const  featurenew  = { ...feature };
    if (mrp){
      featurenew.mrp = mrp;
    }
     
    
     if (stock) {
       featurenew.stock = stock;
        
     } 
    

    if (prodCode){
      featurenew.prodCode = prodCode;
    }

    if (modelNum){
      featurenew.modelNum = modelNum;
    }

    featurenew.isedited = true;

    console.log("handleModelData @@@@@@ : "+ JSON.stringify(feature));

    productList[index] = featurenew;
    setProductList([...productList]);
    console.log("handleModelData : ", productList)
  }

  const showErrorDlg= (msg:string)=> {
      setErrorMsg(msg);
      setDlgOpen(true)
  }

  const submitProduct = () => {

    console.log('submit param before: ', selectedBrandId, selectedSubCatId);
    // A product MUST have a real Brand and Sub-Category. Saving with the subcategory left on
    // "select" used to pass this check (was &&) and stored iProductCategoryId=0, orphaning the
    // product so it showed only in search, never in category browse. Block unless both resolve
    // to a positive id. Fixed 2026-06-24.
    if (selectedBrandId == 'select' || selectedSubCatId == 'select'
        || !(Number(selectedBrandId) > 0) || !(Number(selectedSubCatId) > 0)) {
      showErrorDlg("Please select a Brand, Main Category and Sub Category before saving.")
      return;
    }
    var hasError= false;

    if (productList && productList.length == 0) {
      showErrorDlg("Products cannot be empty! ")
      return ;
    }

    if (productFormData) {
      if (isEditMode) {
        // loop the checkbox fields
          

        console.log('submit ppp  bb ' + "" + JSON.stringify(productFormData));
        const prodData: any = { ...productFormData } 
        console.log('submit proddata ' + "" + JSON.stringify(prodData));
        //console.log("listt : ", availableFeatures);
    
        console.log('submit list :' + productList.length);
        let modData: any[] = []
        
        var createNewProduct = false;

        for (let modindex = 0; modindex < productList.length; modindex++) {
          var proddetails = productList[modindex];
          console.log('submit editt :' +proddetails.isedited);
          //if (proddetails.isedited) 
          {

            var detailsObj :any = {}
            var commonObj :any = {}

            if (proddetails.prodId == -99 ) {
              createNewProduct = true;
            }  else if (checkBoxClickCount <=0) {
                continue;
            }           


           Object.keys(proddetails).forEach(function (key, index) {
            
            if ( proddetails.prodId == -99 ||  editableFields["field_"+key] ) {

                console.log('submit param : ',key.split("_").pop() +  editableFields["field_"+key] + ": "+ proddetails.prodId );
                var keyParam  = key.split("_").pop();
                var valuee = Object(proddetails)[keyParam!!]

                console.log('submit param : vaaaaaaaaaaaaaaaa :: '+ valuee )

                if (keyParam == "finish" ) {
                    commonObj = { ...commonObj  ,[keyParam as string] : valuee}                    

                } else if (keyParam == "dispImg" ) {
                  // if (proddetails.dispImgData) 
                  {
                      commonObj = { ...commonObj  ,[keyParam as string] : valuee ,  dispImgData: proddetails.dispImgData}    
                  }
                             
                } else if ( keyParam == "mrp" || keyParam == "size" || keyParam == "stock" || keyParam == "prodCode"  || keyParam == "modelNum" || keyParam == "status") {
                 
                  detailsObj = {...detailsObj,[keyParam as string] : valuee }; 

                }


                if (keyParam != "errors") {

                  if (keyParam != "prodCodeOld" && (valuee == undefined ||  valuee.length == 0) ) {
                    hasError = true;
                    var paramkey :string = "error_"+[key as string]
                    proddetails.feature_errors = {...proddetails.feature_errors , [paramkey] : true}          
                    // alert('error')                
                  } else {
                    var paramkey :string = "error_"+[key as string]
                    proddetails.feature_errors = {...proddetails.feature_errors , [paramkey] : false}  
                  }
              }
           
            }           
        

            detailsObj = {...detailsObj , "prodCode" : proddetails.prodCode ,  "prodCodeOld" : proddetails.prodCodeOld}


           // modData.push({...commonObj,details : [detailsObj]}) ;
          });  
           
            modData.push({...commonObj,details : [detailsObj]}) ;  
          }
        }

        if (hasError) {
          setProductList([...productList])
          showErrorDlg("Please fill required fields!")
         // alert(JSON.stringify(productList))
         // setErrMsg('Something went wrong while creating the product');
          return;
        }
      
    
    
        const data = {
          ...prodData
         
        };
         
        /*cad: productFormData.cad, cadImgData: productFormData.cadImgData,
        refImg: productFormData.refImg, refImgData: productFormData.refImgData,
        featureList: productFormData.featureList, featureListData: productFormData.featureListData */

        console.log('submit ppp ' + "" + JSON.stringify(modData));
       // console.log('submit param : ', data.value[keyParam]);
        
        var dataModified:any = {}
        Object.keys(data).forEach(function (key, index) {

            
            if (createNewProduct || editableFields["field_"+key]) {
                console.log('submit param : ',key.split("_").pop() +  editableFields["field_"+key]);
                var keyParam  = key.split("_").pop();
                
                var valuee = Object(data)[keyParam!!]

              //  if (valuee != null) 
                { 
                    dataModified = {...dataModified,[keyParam as string] : valuee };  

                    if (keyParam == "cad") {
                        dataModified = {...dataModified,cadImgData :  Object(data)["cadImgData"] };    
                    }
                    if (keyParam == "refImg") {
                        dataModified = {...dataModified,refImgData :  Object(data)["refImgData"] };    
                    }
                    if (keyParam == "featureList") {
                        dataModified = {...dataModified,featureListData :  Object(data)["featureListData"] };    
                    }

                     if (keyParam == "prodDispName" && valuee!=null  && valuee.length == 0) {
                         hasError = true;
                     }

                }

            } 
      
          });

          if (hasError) {
            showErrorDlg("Product Name cannot be empty! ")
            return;
          }

          if (modData==null || modData.length == 0) {
            showErrorDlg("No fields are selected! ")
            return;
          }

          const dataUpdate = {
            ...dataModified, modData
           
          };

          console.log('submit param : ', dataUpdate);


          // validate      


        productService.updateproduct(Number(selectedSubCatId), Number(selectedBrandId), dataUpdate, Number(origBrandId), Number(origSubCatId)).then((res: any) => {

          if (res && res.status == 100) {
           
            toast.success("Product updated successfully", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              hideProgressBar: true,
            });
            setTimeout(() => {
              navigate('../products');
            }, 2100);

          } else {

            showErrorDlg('Something went wrong while updating the product');   

          }
        
        }).catch((err: any) => {
          console.log('err ', err);
          showErrorDlg('Something went wrong while updating the product');
        });


      } else {
        // create produt logic
  

        console.log('submit ppp  bb ' + "" + JSON.stringify(productFormData));
        const prodData: any = { ...productFormData } 
        //console.log("listt : ", availableFeatures);

        if (prodData == undefined || prodData.prodDispName == undefined || prodData.prodDispName.length == 0) {
          showErrorDlg("Product Name cannot be empty! ")
          return true;

        }
    
        console.log('submit list :' + JSON.stringify(productList));
     let modData: any[] = []
        for (let modindex = 0; modindex < productList.length; modindex++) {
          var proddetails = productList[modindex];
  
          // validationn


          Object.keys(proddetails).forEach(function (key, index) {
            
            if (proddetails) {

               // console.log('submit param : ',key.split("_").pop() +  editableFields["field_"+key] + ": "+ proddetails.prodId );
                var keyParam  = key;
                var valuee = Object(proddetails)[keyParam!!]


                if ( keyParam != "prodCodeOld" && ( valuee == undefined ||  valuee.length == 0 )) {
                  hasError = true;
                  var paramkey :string = "error_"+[key as string]
                  proddetails.feature_errors = {...proddetails.feature_errors , [paramkey] : true}          
                  // alert('error '+keyParam)                
               } else {
                  var paramkey :string = "error_"+[key as string]
                  proddetails.feature_errors = {...proddetails.feature_errors , [paramkey] : false}  
               }           
            }
        
            detailsObj = {...detailsObj , "prodCode" : proddetails.prodCode  }



           // modData.push({...commonObj,details : [detailsObj]}) ;
          });

          // validationnn


          //if (proddetails.isedited) 
          {
            modData.push(
              {
                finish: proddetails.finish,
                details: [{
                  "mrp": proddetails.mrp,
                  "size": proddetails.size,
                  "stock": proddetails.stock,
                  "prodCode": proddetails. prodCode,
                  "prodCodeOld" : proddetails.prodCodeOld,
                  "modelNum": proddetails.modelNum,
                  "prodId" : proddetails.prodId
                }],
                dispImg: proddetails.dispImg,
                dispImgData: proddetails.dispImgData
              }
    
            )
          }
        }

        
        if (hasError) {
          setProductList([...productList])
          showErrorDlg("Please fill required fields!")
         // alert(JSON.stringify(productList))
         // setErrMsg('Something went wrong while creating the product');
          return;
        }
      
    
    
        const data = {
          ...prodData, modData, cad: productFormData.cad, cadImgData: productFormData.cadImgData,
          refImg: productFormData.refImg, refImgData: productFormData.refImgData,
          featureList: productFormData.featureList, featureListData: productFormData.featureListData
        };
        console.log('submit ppp ' + "" + JSON.stringify(data));
        console.log('submit param : ', isEditMode, selectedBrandId, selectedSubCatId);


        //productFormData.catId, productFormData.brandId
        productService.createproduct(Number(selectedSubCatId), Number(selectedBrandId), data).then((res: any) => {

          
          if (res && res.status == 100){

            toast.success("Product created successfully", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
              hideProgressBar: true,
            });
            setTimeout(() => {
              navigate('../products');
            }, 2100);

          } else {
            showErrorDlg('Something went wrong while creating the product');
          }

        }).catch((err: any) => {
          console.log('err ', err);
          showErrorDlg('Something went wrong while creating the product');
        });
      }
    }
  }
  



  const onUploadModelImg = (event: SyntheticEvent, index: number) => {

    const element = event.target as HTMLInputElement;
    if (element.files) {
      const file = element.files[0];

      if (!file){
        return;
      }

      if (!isValidFileName(file.name)) {

        showErrorDlg(fileErrormsg)
       // setDlgOpen(true);

        return
      }


      console.log("^^^dispImg[" + index + "]^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const feature = productList[index];
        feature.dispImg = file.name;
        feature.dispImgData = reader.result as string;

        productList[index] = feature;
        setProductList([...productList]);

       
       // setDispImgState(feature.dispImg);

      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  const onUploadCadImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];

      if (!isValidFileName(file.name)) {

        showErrorDlg(fileErrormsg)

        return
      }

      console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
      //  const prodData = { ...productFormData };
        productFormData.cad = file.name;
       
        productFormData.cadImgData = reader.result as string;
       // console.log("^^^Cad^^^^^^^^^^^filedata : " +prodData.cadImgData ) ;
    
       setCadState(file.name)
      //var  productFormDatalocal = {...productFormData, cad :file.name , cadImgData : reader.result as string }
        setProductFormData(productFormData);
                

        //alert(JSON.stringify(productFormData))
      }
      reader.onerror = (e) => { console.log('err') }
    }
  }
  const onUploadRefImg = (event: SyntheticEvent) => {

    const element = event.target as HTMLInputElement;
    if (element.files) {
      const file = element.files[0];

      if (!isValidFileName(file.name)) {

        showErrorDlg(fileErrormsg)

        return
      }

      console.log("^^^^^refImg^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const prodData = { ...productFormData };
        prodData.refImg = file.name;
        prodData.refImgData = reader.result as string;
        setProductFormData(prodData);
        setRefImgState(file.name);
      }
      reader.onerror = (e) => { console.log('err') }
    }
  }
  const onUploadFeatureList = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {
      const file = element.files[0];

      if (!file){
        return;
      }

      if (!isValidFileName(file.name)) {

        showErrorDlg(fileErrormsg)

        return
      }
      console.log("^^^^^feature^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const prodData = { ...productFormData };
        prodData.featureList = file.name;
        prodData.featureListData = reader.result as string;
        setProductFormData(prodData);
        setFeatImgState(file.name);
      }
      reader.onerror = (e) => { console.log('err') }
    }
  }
  const updateSelectedSize = (val: string, index: number) => {
    const feature = productList[index];
    const selectedSize: any = availableSizes.find((el: any) => el.unit === val);

    if (selectedSize) {
      feature.sizeUnit = val;
      feature.selectedSizes = [...selectedSize.sizes];
    }

    setProductList([...productList]);
  }

  const onCancelProduct = () => {
    navigate("../products");
  }

  //const extparam : {  brandId: '', groupModelNo: ''   } 

  const onFormUpdate = (data: any) => {
    console.log("logg ",data.value);
    productCommonDataDelta.value = data.value;
    Object.keys(data.value).forEach(function (key, index) {

      productFormData[key] = data.value[key]
      

    });
    const dataa = { ...productFormData }

    const delta = { ...productCommonDataDelta }

    setProductCommonDataDelta(delta)

    //  console.log('onFormUpdate :  ',productFormData);
    //   console.log('onFormUpdate param :  ',data.value);

    // let param1 = {...productFormData}
    //  let param2 = {...data}
    //  const allRules = {...param1 ,...param2}
    console.log('onFormUpdate copied :  ', dataa);
    setProductFormData(dataa);
  }

  const updateFieldKeys = (key: string, event: SyntheticEvent) => {
    let fieldsData: any = { ...editableFields };
    fieldsData[key] = (event.target as HTMLInputElement).checked;

    if ((event.target as HTMLInputElement).checked){
      setcheckBoxClickCount(checkBoxClickCount+1);
    } else {
      setcheckBoxClickCount(checkBoxClickCount-1);
    }

    //var keyParam  = key.split("_").pop();
   // if (keyParam == "finish" || keyParam == "dispImg" ||  keyParam == "mrp" || keyParam == "size" || keyParam == "stock"  || keyParam == "modelNum" || keyParam == "status") {
   //    setproductEditAllowed()
   // }

    setEditableFields(fieldsData);
  }

  const all_fields: readonly string[] = [
    //"field_prodCatId",
    //"field_prodCatId",
    "field_prodCatId",  // done
    "field_prodDispName", // done
    "field_groupModelNo", // done
    "field_isnew", // done
    "field_videoUrl", // done
    "field_remark", // done
    "field_cad", // done 
    "field_refImg", // done
    "field_featureList", //done
    "field_prodCode", // done
    "field_modelNum", // done
    "field_finish", // done
    "field_size", // done
    "field_mrp", // done
    "field_dispImg", // done
    "field_stock", // done
    "field_status",
    "field_delRow"
  ];

  const unsetFieldKeys = () => {
    let fieldsData: any = { ...editableFields };
    // fieldsData[] = (event.target as HTMLInputElement).checked;

    for (var fieldd of all_fields) {
      fieldsData[fieldd] = false;
    }

    console.log('fields :', fieldsData);
    setEditableFields(fieldsData);
  }


  const onSubmitFields = () => {
    console.log('fields ', editableFields);
    setCanShowForm(true);
  }

  const checkHideState = (): boolean => {

    return isEditMode &&

      (editableFields.field_prodCode ||
        editableFields.field_modelNum ||
        editableFields.field_finish ||
        editableFields.field_size ||
        editableFields.field_mrp ||
        editableFields.field_dispImg ||
        editableFields.field_stock)
  }

  const closeDialog = () => {

    setDlgOpen(false);       
};


  return (
    <div className="App"> 
      {!canShowForm && <div className="card m-5">
        <div className="card-header p-0 text-left">
          <label >Select Fields To Edit</label>
        </div>
        <div className="card-body">
          <div className="row text-left">
            <div className="col-md-12">
              {/* <FormBuilder onUpdate={setEditableFields}> */}
              {/* <div className="col-md-6"><strong className=''>Field</strong></div> */}
              {/*<div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_prodCatId', e)} type="checkbox" name="field_prodCatId" id="" className='mr-2' /> Brand</div>*/}
              {/*<div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_prodCatId', e)} type="checkbox" name="field_prodCatId" id="" className='mr-2' /> Main Category</div>*/}
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_prodCatId', e)} type="checkbox" name="field_prodCatId" id="" className='mr-2' /> Product Category</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_prodDispName', e)} type="checkbox" name="field_prodDispName" id="" className='mr-2' /> Product Name</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_groupModelNo', e)} type="checkbox" name="field_groupModelNo" id="" className='mr-2' /> Group Model No</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_videoUrl', e)} type="checkbox" name="field_videoUrl" id="" className='mr-2' /> Installation Video Url</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_remark', e)} type="checkbox" name="field_remark" id="" className='mr-2' /> Remark</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_isnew', e)} type="checkbox" name="field_isnew" id="" className='mr-2' /> isNew</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_cad', e)} type="checkbox" name="field_cad" id="" className='mr-2' /> CAD Drawing</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_refImg', e)} type="checkbox" name="field_refImg" id="" className='mr-2' /> Reference Images</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_featureList', e)} type="checkbox" name="field_featureList" id="" className='mr-2' /> Feature List</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_prodCode', e)} type="checkbox" name="field_prodCode" id="" className='mr-2'  /> Product Code</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_modelNum', e)} type="checkbox" name="field_modelNum" id="" className='mr-2' /> Model Number</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_finish', e)} type="checkbox" name="field_finish" id="" className='mr-2' /> Finish</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_size', e)} type="checkbox" name="field_size" id="" className='mr-2' /> Size</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_mrp', e)} type="checkbox" name="field_mrp" id="" className='mr-2' /> MRP</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_stock', e)} type="checkbox" name="field_stock" id="" className='mr-2' disabled /> Stock</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_dispImg', e)} type="checkbox" name="field_dispImg" id="" className='mr-2' /> Display Image</div>
              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_status', e)} type="checkbox" name="field_status" id="" className='mr-2' /> Status</div>

              <div className="col-md-6"><input onChange={(e) => updateFieldKeys('field_delRow', e)} type="checkbox" checked hidden name="field_delRow" id="" className='mr-2' /> </div>


              {/* </FormBuilder> */}
            </div>
          </div>
        </div>
        <div className="card-footer text-left">
          <button type="button" onClick={onSubmitFields} className="btn btn-ghost-success btn-outline-success btn-sm mt-3 pl-2 pr-2 mr-2">Confirm</button>
          <button type="button" onClick={() => navigate('../products')} className="btn btn-ghost-success btn-outline-secondary btn-sm mt-3 pl-3 pr-3">Cancel</button>
        </div>
      </div>
      }
      {canShowForm && <div className="card md-6">

        <div className="card-header p-0 text-left">
          <label className='ml-4 mt-1'>Basic product details</label>
        </div>
        <div className="card-body">
          <FormBuilder onUpdate={onFormUpdate} showValidations={false}>

            <div className="row   ">

              <div className="col-4 form-group text-left">
                <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_prodCatId} className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}

                  onChange={(e: any) => {
                    setSelectedBrandId(e.target.value)

                    const prodData = { ...productFormData };
                    prodData.brandId = e.target.key;

                    setProductFormData(prodData);

                    //console.log('sellbb :: ',productFormData);

                    loadAllCategories(e.target.value)
                  }}  >
                  <MenuItem value="select" key="select" disabled>Select</MenuItem>
                  {availableBrands.map((_el: any) => <MenuItem key={_el.brandId} value={_el.brandId}>{_el.brandName}</MenuItem>)}
                </TextField>
              </div>
              <div className="col-4  form-group  text-left">
                <TextField select size="small" label="Main Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_prodCatId} className="form-control" name='mainCategory' value={selectedCatId} defaultValue="select"
                  onChange={(e: any) => {
                    setSelectedCatId(e.target.value)
                    loadSubCategories(e.target.value)
                  }}  >
                  <MenuItem value="select" key="select"  disabled>Select</MenuItem>
                  {availableCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}>{_el.catName}</MenuItem>)}
                </TextField>
              </div>
              <div className="col-4  form-group text-left">
                <TextField select size="small" label="Sub Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_prodCatId} className="form-control" name='subCategory' value={selectedSubCatId} defaultValue=""
                  onChange={(e: any) => {
                    setSelectedSubCatId(e.target.value)
                  }}
                >
                  <MenuItem value="select" key="select" disabled >Select</MenuItem>
                  {availableSubCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}>{_el.catName}</MenuItem>)}
                </TextField>
              </div>
              <div className="col-4 form-group text-left">
                <TextField size="small" label="Product Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_prodDispName} type="text" className="form-control" name='prodDispName' 
                    value={productFormData.prodDispName} 
                    onChange={(e: any) => { 
                      productFormData.prodDispName = e.target.value
                      setProductFormData({...productFormData})
                    }
                    }
                  
                />
              </div>
              <div className="col-4 form-group  text-left">
                <TextField size="small" label="Group Model No" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_groupModelNo} type="text" className="form-control" name='groupModelNo'
                   value={productFormData.groupModelNo}
                   onChange={(e: any) => { 
                    productFormData.groupModelNo = e.target.value
                    setProductFormData({...productFormData})
                  }
                }
                />
              </div>
              <div className="col-4 form-group  text-left">
                <TextField size="small" label="Installation Video URL" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_videoUrl} type="text" className="form-control" name='videoUrl' 
                 


                  value={productFormData.videoUrl}
                  onChange={(e: any) => { 
                   productFormData.videoUrl = e.target.value
                   setProductFormData({...productFormData})
                 }
               }

                />
              </div>
              <div className="col-4 form-group  text-left">
                <TextField size="small" label="Remark" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  disabled={isEditMode && !editableFields.field_remark} type="text" className="form-control" name='remark' 
                  

                  value={productFormData.remark}
                  onChange={(e: any) => { 
                   productFormData.remark = e.target.value
                   setProductFormData({...productFormData})
                 }
               }


                />
              </div>
              <div className="row col-4 form-group text-left">
                <div className="form-group"   >
                  <label className="mt-2 ml-4 pr-3">isNew</label>
                </div>
                <div className="form-group" >
                  <FormControl>

                    <RadioGroup row name='isnew' value={productFormData.isnew}
                      onChange={(e: any) => { handleIsNew(e, e.target.value) }}
                    >
                      <FormControlLabel disabled={isEditMode && !editableFields.field_isnew} value="Y" label="Yes" control={<Radio size="small" color="success" />} />
                      <FormControlLabel disabled={isEditMode && !editableFields.field_isnew} value="N" label="No" control={<Radio size="small" color="error" />} />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>
            </div>


            <div className='row mb-5' >
              <div className='col-md-4 text-left mb-1 '>
                <TextField size="small" label="Cad Image/PDF" id="outlined-start-adornment" inputProps={{ accept: "application/pdf" }} InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                  disabled={isEditMode && !editableFields.field_cad} className="form-control" name='cad' value={cadState}
                  helperText={'. jpg | . jpeg | . png | . pdf file'}
                  InputProps={{
                    sx: { height: 35 },
                    endAdornment: (
                      <IconButton component="label" disabled={isEditMode && !editableFields.field_cad} >
                        <FileUploadOutlinedIcon />
                        <input style={{ display: "none" }} type="file" hidden onChange={(event) => onUploadCadImg(event)} name="cadFileHiddenImg"
                        />
                      </IconButton>
                    ),
                  }}
                />

                {/*
                <div className="col-4 form-group  pl-0">
                  <TextField size="small" label="Selected Cad Image/PDF" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} sx={{ m: 0, width: '57ch' }}
                    disabled={isEditMode && !editableFields.field_cad} type="text" className="form-control" name='cad' value={""}
                  />
                </div>
                  */}
              </div>
              <div className='col-md-4 text-left'>

                <TextField size="small" label="Reference Image" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                  disabled={isEditMode && !editableFields.field_refImg} className="form-control" name='refImg' value={refImgState}
                  helperText={'. jpg | . jpeg | . png | . pdf file'}
                  InputProps={{
                    sx: { height: 35 },
                    endAdornment: (
                      <IconButton component="label" disabled={isEditMode && !editableFields.field_refImg} >
                        <FileUploadOutlinedIcon />
                        <input style={{ display: "none" }} type="file" hidden onChange={(event) => onUploadRefImg(event)} name="refImgHiddenInput"
                        />
                      </IconButton>
                    ),
                  }}
                />

                {/*
                <div className="col-4 form-group  pl-1">
                  <TextField size="small" label="Selected Reference Image" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} sx={{ m: 0, width: '57ch' }}
                    disabled={isEditMode && !editableFields.field_refImg} type="text" className="form-control" name='refImg' value={""}
                  />
                </div>
                */}
              </div>
              <div className='col-md-4 text-left'>

                <TextField size="small" label="Feature List" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                  disabled={isEditMode && !editableFields.field_featureList} className="form-control" name='featImg' value={featImgState}
                  helperText={'. jpg | . jpeg | . png | . pdf file'}
                  InputProps={{
                    sx: { height: 35 },
                    endAdornment: (
                      <IconButton component="label" disabled={isEditMode && !editableFields.field_featureList} >
                        <FileUploadOutlinedIcon />
                        <input style={{ display: "none" }} type="file" hidden onChange={(event) => onUploadFeatureList(event)} name="featImgHiddenInput"
                        />
                      </IconButton>
                    ),
                  }}
                />

                {/*
                <div className="col-4 form-group  pl-1">
                  <TextField size="small" label="Selected Reference Image" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} sx={{ m: 0, width: '57ch' }}
                    disabled={isEditMode && !editableFields.field_refImg} type="text" className="form-control" name='featureList' value={""}
                  />
                </div>
                */ }
              </div>

            </div>
          </FormBuilder>



          <div className='text-left '>
            <div className="border-top">
              {
                productList.map((el, index) => <div key={el.uuid}>
                  <FormBuilder onUpdate={(data) => handleModelData(index, data)} showValidations={false} >
                    <div className="row no-gutters mt-3 "  >

                      <div className="col-2 form-group pr-1">
                        <TextField   size="small" label="Product Code" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={ (el.prodId != -99) && isEditMode && !editableFields.field_prodCode } type="text" className="form-control" name='prodCode' 
                          /*value={el.prodCode} */
                           error = {el!!.feature_errors!!.error_prodCode}
                           defaultValue={el.prodCode}
                        />
                      </div>
                      <div className="col-2 form-group pr-1">
                        <TextField size="small" label="Model No" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_modelNum} type="text" className="form-control" name='modelNum' 
                          /*value={el.modelNum} */
                          error = {el!!.feature_errors!!.error_modelNum}
                          defaultValue={el.modelNum}
                        />
                      </div>

                      <div className="col-2  form-group pr-1">
                        <TextField select size="small" label="Finish" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_finish} className="form-control" name='finish' 
                          value={el.finish}
                          error = {el!!.feature_errors!!.error_finish}
                          onChange={(e: any) => { setselectedFinish(e, e.target.value, index) }}
                        >
                          <MenuItem value={"select"} >Select</MenuItem>
                          {availableFinishes.map((_el: any) => <MenuItem value={_el.colorCode}>{_el.colorCode}</MenuItem>)}
                        </TextField>
                      </div>
                      <div className="col-2 form-group pr-1">
                        <TextField select size="small" label="Size Unit" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_size} className="form-control" 
                          value={el.sizeUnit} name='sizeUnit' onChange={(event) => updateSelectedSize(event?.target.value, index)}>
                          <MenuItem>Select</MenuItem>
                          {availableSizes?.map((_el: any) => <MenuItem value={_el.unit}>{_el.unit}</MenuItem>)}
                        </TextField>
                      </div>
                      <div className="col-2 form-group pr-1">
                        <TextField select size="small" label="Size" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_size} className="form-control" name='size' value={el.size}
                          onChange={(e: any) => { setselectedSize(e, e.target.value, index) }}

                        >
                          <MenuItem value='select'>Select</MenuItem>
                          {el.selectedSizes?.map((_el: any) => <MenuItem value={_el.size}>{_el.size}</MenuItem>)}
                        </TextField>
                      </div>
                      <div className="col-2 form-group pr-1">
                        <TextField size="small" label="Selected Size" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_size} type="text" className="form-control" name='selectedSize' value={el.size}
                          error = {el!!.feature_errors!!.error_size}
                        />
                      </div>
                    </div>
                    <div className="row no-gutters border-bottom">
                      <div className="col-2 form-group pr-1">
                        <TextField size="small" label="Mrp" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_mrp} type="number" className="form-control" name='mrp' 
                          /*value={el.mrp} */
                          error = {el!!.feature_errors!!.error_mrp}
                          defaultValue={el.mrp}
                        />
                      </div>
                      <div className="col-2 form-group pr-1">
                        <TextField size="small" label="Stock" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_stock} type="number" className="form-control" name='stock' 
                          /*value={el.stock} */
                          error = {el!!.feature_errors!!.error_stock}
                          defaultValue={el.stock}
                        />
                      </div>
                      <div className="col-4  form-group ">
                        <TextField size="small" label="Display Image" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} variant="outlined"
                          disabled={el.prodId != -99 && isEditMode && !editableFields.field_dispImg} type="text" className="form-control" name='dispImg' value={el.dispImg}
                          error = {el!!.feature_errors!!.error_dispImg}
                          InputProps={{
                            sx: { height: 35 },
                            endAdornment: (
                              <IconButton component="label" disabled={el.prodId != -99 && isEditMode && !editableFields.field_dispImg}  >
                                <FileUploadOutlinedIcon />
                                <input style={{ display: "none" }} type="file" onChange={(event) => onUploadModelImg(event, index)} name="dispImg"
                                />
                              </IconButton>
                            ),
                          }}
                        />
                      </div>
                      {/*
                      <div className="col-2 form-group ">
                        <TextField size="small" label="Selected Disp Image" id="outlined-start-adornment" 
                          disabled={isEditMode && !editableFields.field_dispImg} type="text" className="form-control" name='dispImg' value={""}
                        />
                      </div>
                      */ }

             <div className="row col-3 form-group text-left">
                <div className="form-group"   >
                  <label className="mt-2 ml-4 pr-3">Status</label>
                </div>
                <div className="form-group" >
                  <FormControl>

                    <RadioGroup row name='status' value={el.status}
                      onChange={(e: any) => { handleStatus(e, e.target.value,index) }}
                    >
                      <FormControlLabel disabled={el.prodId != -99 && isEditMode && !editableFields.field_status} value="1" label="Active" control={<Radio size="small" color="success" />} />
                      <FormControlLabel disabled={el.prodId != -99 && isEditMode && !editableFields.field_status} value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>


                      <div className="col-1 form-group text-right "  hidden={el.prodId != -99}  >
                        <span onClick={() => onRemoveFeature(el)}  >
                          <IconButton component="label"   >
                            <RemoveCircleOutlineTwoToneIcon fontSize='small' htmlColor='red' />
                          </IconButton></span>
                      </div>
                    </div>

                  </FormBuilder>
                </div>)
              }
            </div>
            <div className="mt-2" >
              <span onClick={onAddNewFeature} >
                <IconButton component="label" disabled={isEditMode 
              && (!editableFields.field_prodCode || !editableFields.field_modelNum || !editableFields.field_size ||
                !editableFields.field_mrp || !editableFields.field_dispImg)} >

                <AddCircleOutlineTwoToneIcon fontSize='medium' htmlColor='green' />
              </IconButton></span>
              <span><i className="ml-2" style={{ fontSize: '16px', color: 'green' }} aria-hidden="true">Click to add specific product details</i></span>
              {/*
            <button disabled={isEditMode && (!editableFields.field_prodCode || !editableFields.field_modelNum || !editableFields.field_size || 
              !editableFields.field_mrp || !editableFields.field_dispImg)} 
              className="btn btn-ghost-success btn-outline-success btn-sm mt-3 pl-2 pr-2" onClick={onAddNewFeature}>Add New
            </button> */}
            </div>
          </div>
        </div>

        <div className="card-footer col-12 text-center">

          <Button  style={{ color: "green" }} className="mr-4" onClick={submitProduct}   variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={onCancelProduct} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>

        </div>
      </div>}
      <ToastContainer

      />

{openDlg && <MyCustomNotification title="Alert !!!" message={errorMsg}  onClose={closeDialog} ></MyCustomNotification>}
    </div >
  );
}

export default ProductDetails;
